export const SITE_URL = 'https://frame.chwan.cc';
export const APP_NAME = 'LumaFrame';
export const DEFAULT_LOCALE = 'en';

export const PUBLIC_ROUTES = ['/', '/about', '/support'] as const;

export function absoluteUrl(path = '/'): string {
  return new URL(path, SITE_URL).toString();
}

export function localizedPath(path: string, locale: string): string {
  const normalizedPath = path === '/' ? '/' : path.replace(/\/$/, '');
  return `${normalizedPath}?lang=${locale}`;
}
